var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("b-button", { attrs: { block: "" }, on: { click: _vm.clickButton } }, [
        _vm._v("移行元の更新チェック" + _vm._s(_vm.loadingText)),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }